import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  padding: 1,
  display: 'flex',
  alignItems: 'center',
};
